import libphonenumber from 'google-libphonenumber'

const phoneNumberUtil = libphonenumber.PhoneNumberUtil.getInstance()
const numberFormat = new libphonenumber.NumberFormat()

export default function formatPhoneNumber(phoneNumberString, phoneFormat, phonePrefix, isInternational, indic) {
  
  if(indic){
    var tempFormat = phoneFormat.substr(2, 1);
    console.log("indic = " + phoneNumberString + " / "+indic + ' / '+tempFormat)
    phoneFormat = "$1"+tempFormat+"$2"+tempFormat+"$3"
  }
  try {
    phoneNumberUtil.parseAndKeepRawInput(phoneNumberString, 'CA')
  } catch (error) {
    return phoneNumberString
  }
  const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(phoneNumberString, 'CA')
  numberFormat.setPattern("(\\d{3})(\\d{3})(\\d{4})")
  numberFormat.setFormat(phoneFormat)

  const formatedNumber = phoneNumberUtil.formatByPattern(phoneNumber, libphonenumber.PhoneNumberFormat.NATIONAL, [numberFormat])

  const prefix = isInternational ? phoneNumber.getCountryCode() + phonePrefix : ''

  return `${prefix}${formatedNumber}`
}
